// extracted by mini-css-extract-plugin
export default {"search":"SearchInput_search__dOmKg"};